export default __webpack_public_path__ + "static/media/campus (3).7c9ce4f6.JPG";